
import { Component, Mixins } from 'vue-property-decorator';
import { VuetifyMixin, BAIconsMixin, UpgradeNowMixin, MyAthleteMixin } from '@/mixins';
import { SportName } from '@/../types';

class Promotion {
    id: string = "";
    name: string = "Promotion";
    code: string = "BA5";
    discount: string = "5%";
    appliesTo: string = "All Subscriptions";
    hidden: boolean = false;
    current: boolean = true;
    sport?: SportName;
};

@Component
export default class PromotionsCard extends Mixins(VuetifyMixin, BAIconsMixin, UpgradeNowMixin, MyAthleteMixin) {
	baImg: string = 'https://cdn.bestathletes.co/static-assets/bestie-square-100x100.png';
	baImgSize: string = "100";

    showFoundPromos: boolean = false;
    mounted() {
        setTimeout(() => this.onFoundPromos(), 2500)
    }

    get SeasonTitle(): string {
        if( this.IsDecember ) return "Holiday Sale";
        if( this.IsWinter ) return "Winter Sale";
        if( this.IsSpring ) return "Spring Sale";
        if( this.IsSummer ) return "Summer Sale";
        if( this.IsAutumn ) return "Fall Sale";
        return "Sale"
    }
    get SeasonColor(): string {
        if( this.IsDecember ) return "green lighten-1";
        if( this.IsWinter ) return "white darken-1";
        if( this.IsSpring ) return "yellow lighten-4";
        if( this.IsSummer ) return "green lighten-4";
        if( this.IsAutumn ) return "orange lighten-3";
        return "secondary"
    }
    get SeasonHighlightColor(): string {
        if( this.IsDecember ) return "red darken-2";
        if( this.IsWinter ) return "black";
        if( this.IsSpring ) return "blue lighten-2";
        if( this.IsSummer ) return "brown";
        if( this.IsAutumn ) return "red darken-3";
        return "success"
    }

    onFoundPromos() {
        this.showFoundPromos = true;
    }
    promotions: Array<Promotion> = [
        {
            id: "00000001",
            name: "Showcase 2024",
            code: "SHOWCASEATHLETE2024",
            discount: "10%",
            appliesTo: "Showcase Subscription",
            hidden: false,
            current: false,
        },
        {
            id: "00000002",
            name: "Elite",
            code: "ELITEATHLETE2024",
            discount: "20%",
            appliesTo: "Elite Subscription",
            hidden: false,
            current: false,
        },
        {
            id: "00000010",
            name: "Showcase Twenty",
            code: "BASHOWCASE20",
            discount: "20%",
            appliesTo: "Showcase Subscription",
            hidden: false,
            current: true,
        },
        {
            id: "00000020",
            name: "Elite Fifty",
            code: "BAELITE50SC",
            discount: "50%",
            appliesTo: "Elite Subscription",
            hidden: false,
            current: false,
        },
        {
            id: "00000200",
            name: "Elite Forty",
            code: "BAELITE40BJ",
            discount: "40%",
            appliesTo: "Elite Subscription",
            hidden: true,
            current: true,
        },
        {
            id: "20000000",
            name: "Rugby Eighty",
            code: "PANTHERELITE80",
            discount: "80%",
            appliesTo: "Elite Subscription",
            hidden: false,
            current: true,
            sport: SportName.Rugby,
        },
    ];
}

